module.exports = __webpack_public_path__ + "img/1280x720-Business.c9dd5693.jpg";